import React from 'react';
import './RadioButton.css'; // Импортируем CSS-файл

interface RadioButtonProps extends React.ComponentProps<'input'> {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  name: string;
  value: string;
  variant?: 'primary' | 'secondary';
  defaultChecked?: boolean;
  disabled?: boolean;
  labelProps?: React.ComponentProps<'span'>;
  indicatorProps?: React.ComponentProps<'div'>;
}

export const RadioButton = ({
  onChange,
  labelProps,
  indicatorProps,
  variant = 'primary',
  disabled = false,
  label,
  ...props
}: RadioButtonProps) => {
  const { className: labelClassName, ...otherLabelProps } = labelProps || {};
  const { className: indicatorClassName, ...otherIndicatorProps } = indicatorProps || {};

  return (
    <label
      className={`radio-button radio-button--${variant} ${disabled ? 'radio-button--disabled' : ''} radio-button--shrink`}
    >
      <input
        className="radio-button__input"
        type="radio"
        {...props}
        disabled={disabled}
        defaultChecked={props?.defaultChecked}
        onChange={(e) => onChange?.(e)}
      />
      <div className="radio-button__label">
        <span
          className={`radio-button__indicator ${indicatorClassName || ''}`}
          {...otherIndicatorProps}
        />
      </div>
      {label && (
        <span
          className={`radio-button__text ${labelClassName || ''}`}
          {...otherLabelProps}
        >
          {label}
        </span>
      )}
    </label>
  );
};
